import DataTable from "react-data-table-component";

import CellBuilder from "components/cell-builder/CellBuilder";
import ElipsisMenu, { MenuItem } from "components/elipsis-menu/ElipsisMenu";
import { useState } from "react";
import SliderPanel from "components/sliderPanel/SliderPanel";
import dateFormatter from "utils/dateFormater";
import TrailerDetails from "./TrailerDetails";
import { deleteElement, putElement } from "services/apiEndpoints/Endpoints";
import BorderedText from "components/bordered-text/BorderedText";
import joinStrings from "utils/joinStrings";
import CustomPagination from "components/custom-pagination/CustomPagination";
import { useTranslation } from "react-i18next";

function TableTrailers({
  vehicles,
  getVehicles,
  updateVehiclesNDashboard,
  request,
  setRequest,
}) {
  const [vehicleState, setVehicleState] = useState(false);
  const { t } = useTranslation();
  const columns = [
    {
      name: "Vehicle",
      selector: (row) =>
        CellBuilder(
          row.unitNumber || "",
          joinStrings([row.ownership, row.make], " | ")
        ),
      grow: 2,
    },
    {
      name: "Carrier",
      selector: (row) => CellBuilder(row.carrierName || ""),
      grow: 2,
    },
    {
      name: "Chassis Number",
      selector: (row) => {
        return CellBuilder(row.vin || "");
      },

      grow: 2,
    },
    {
      name: "Plate",
      selector: (row) => {
        let a = `${row.plateNumber || ""} (${row.plateState || ""})`;
        return CellBuilder(
          a,
          dateFormatter(row.plateExpiration, "DD MMM YYYY", true)
        );
      },
      grow: 2,
    },
    {
      name: "Last known Location",
      selector: (row) =>
        CellBuilder(
          row.lastKnownLocation || "",
          dateFormatter(row.lastSeen, "DD MMM, HH:mm")
        ),
      grow: 2,
    },

    {
      name: "Status",
      selector: (row) =>
        CellBuilder(
          <BorderedText
            text={row.status || ""}
            classes={(row.status || "").replaceAll(" ", "")}
          />
        ),
      grow: 2,
    },
    {
      name: "Actions",
      selector: (row) => (
        <div className="table-actions">
          <i
            onClick={() => setVehicleState(row.trailerId)}
            className="mil-edit-o"
            style={{ cursor: "pointer", fontSize: "21px" }}
          />
          <ElipsisMenu>
            <MenuItem
              title={t("Edit")}
              onClick={() => setVehicleState(row.trailerId)}
            />
            {row.status === "Revoked" && (
              <MenuItem
                title={t("Re-Authorize")}
                onClick={() =>
                  putElement(
                    `/Authority/trailer/${row.trailerId}/Authorize`
                  ).then(() => updateVehiclesNDashboard())
                }
              />
            )}
            {row.status === "Authorized" && (
              <MenuItem
                title={t("Revoke Authority")}
                onClick={() =>
                  deleteElement(
                    `/Authority/trailer/${row.trailerId}`
                  ).then(() => updateVehiclesNDashboard())
                }
              />
            )}
            {row.status === "Authorized" && (
              <MenuItem
                title={t("Decommission")}
                onClick={() =>
                  putElement(
                    `/Authority/trailer/${row.trailerId}/Decommission`
                  ).then(() => updateVehiclesNDashboard())
                }
              />
            )}
            {(row.status === "Not Authorized" ||
              row.status === "Decommissioned") && (
              <MenuItem
                title={t("Authorize")}
                onClick={() =>
                  putElement(
                    `/Authority/trailer/${row.trailerId}/Authorize`
                  ).then(() => updateVehiclesNDashboard())
                }
              />
            )}
          </ElipsisMenu>
        </div>
      ),
      grow: 1,
    },
  ];

  return (
    <div className="summary-list">
      <SliderPanel isOpen={vehicleState} setIsOpen={setVehicleState}>
        <TrailerDetails
          setIsOpen={setVehicleState}
          getVehicles={getVehicles}
          id={vehicleState}
        />
      </SliderPanel>
      <DataTable
        columns={columns.map((c) => ({
          ...c,
          name: t(c.name),
        }))}
        data={vehicles}
      />
      <CustomPagination
        setRequest={setRequest}
        request={request}
        nextExists={vehicles?.length >= request.limit}
      />
    </div>
  );
}

export default TableTrailers;
